import isNewConsumerApp from 'commons/isNewConsumerApp';
import SuspenseWithLoaderLegacy from './SuspenseWithLoaderLegacy';
import SuspenseWithLoaderNew from './SuspenseWithLoaderNew';

const SuspenseWithLoader = isNewConsumerApp
  ? SuspenseWithLoaderNew
  : SuspenseWithLoaderLegacy;

export default SuspenseWithLoader;
